import React, { useState, useEffect } from 'react'
import Title from '../../Title'
import Select from 'react-select'
import NumberHorizontalLayout from '../../layouts/NumberHorizontalLayout'
import classnames from 'classnames'


export default function ExitSurvey(props) {
  let metrics = [
    {
      title: 'Maintained Sobriety Percentage',
      format: 'number_horizontal_full',
      endpoint: 'maintained_sobriety_percentage',
      visible: true,
    },
    {
      title: 'Active in 12 steps',
      format: 'number_horizontal_full',
      endpoint: 'active_in_12_steps_percentage',
      visible: true,
    },
    {
      title: 'Legal issues post discharge',
      format: 'number_horizontal_full',
      endpoint: 'legal_issues_post_discharge_percentage',
      visible: true,
    },
    {
      title: 'Families active in alumni support',
      format: 'number_horizontal_full',
      endpoint: 'families_active_in_alumni_support_percentage',
      visible: true,
    },
    {
      title: 'Alumni residing in a sober living home',
      format: 'number_horizontal_full',
      endpoint: 'residing_in_sober_home_percentage',
      visible: true,
    },
  ]

  return(
    <div>
      <div className="ml-4">
        <div className="col-12 mt-4 bg-white p-0 shadow">
          <div className="bg-info p-3">
            <div className="col-12 text-align-left title">Exit Survey</div>
          </div>
          <div className="col-12 d-flex flex-wrap p-4 ml-2">
            {
            metrics.filter( metric => metric.visible == true ).map( (metric, index) => {
              return <div className={classnames("pt-3", "col-12", "col-lg-6", "pl-0", { "pl-lg-3": true })} >
                <div className='bg-reg shadow mt-2'>
                  <NumberHorizontalLayout {...props} metric={metric} index={index} /> 
                </div>
              </div>
            })
            }
          </div>
        </div>
      </div>

    </div>
  )
}
